import { CoreModule } from "@abp/ng.core";
import { NgbDropdownModule } from "@ng-bootstrap/ng-bootstrap";
import { NgModule } from "@angular/core";
import { CommercialUiModule } from "@volo/abp.commercial.ng.ui";
import { ThemeSharedModule } from "@abp/ng.theme.shared";
import { NgxValidateCoreModule } from "@ngx-validate/core";
import { CommonModule } from '@angular/common';
import { ReportStatusTagComponent } from './components/report-status-tag/report-status-tag.component';
import { ReportStatusDotComponent } from './components/report-status-dot/report-status-dot.component';

@NgModule({
  declarations: [
    ReportStatusTagComponent,
    ReportStatusDotComponent
  ],
  imports: [
    CoreModule,
    ThemeSharedModule,
    CommercialUiModule,
    NgbDropdownModule,
    NgxValidateCoreModule,
    CommonModule
  ],
  exports: [
    CoreModule,
    ThemeSharedModule,
    CommercialUiModule,
    NgbDropdownModule,
    NgxValidateCoreModule,
    ReportStatusTagComponent,
    ReportStatusDotComponent
  ],
  providers: []
})
export class SharedModule {}
